import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaArrowRight } from "react-icons/fa";
import "./QuickLinks.css";
import { Link, useLocation } from "react-router-dom";
import File1 from "./../../assets/pdf/49thAGMNotice2022-2023.pdf";
import File2 from "./../../assets/pdf/CorporateSocialResponsibilityPolicyoftheCorporation.pdf";
import File3 from "./../../assets/pdf/VigilMechanismPolicyoftheCorporation.pdf";
import img1 from "./../../assets/img/img1.jpg";
import img2 from "./../../assets/img/img2.jpg";
import img3 from "./../../assets/img/img3.jpg";
import img4 from "./../../assets/img/img-npi_0.jpg";
import axios from "axios";
import BaseUrl from "../../base-api";
const QuickLinks = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [notifications, setNotifications] = useState([]);
  const [viewNotifications, setViewNotifications] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const resNote = await axios.post(
          `${BaseUrl}/api/notifications/web/getNotification`,
          { location: "Home Page" },
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        if (resNote.data.status === 200) {
          setNotifications(
            resNote.data.data.map((img) => ({
              id: img.key,
              title: img.title,
              file: `data:application/pdf;base64,${img.file}` || "",
              location: img.location,
            }))
          );
        } else {
          console.error("Failed to fetch Notifications.");
        }
      } catch (error) {
        console.error(error.response?.data?.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    if (location.pathname) fetchData();
  }, [location.pathname]);

  useEffect(() => {
    
    setViewNotifications(notifications.length >5 ? notifications.slice(0, 5): notifications);
    }, [notifications]);

  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains("dark-mode-body"));
    };

    checkDarkMode();

    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

const handleItemClick = async (item) => {
  try {
   
      const resNote = await fetch(`${BaseUrl}/api/notifications/document/${item.id}`, {
        method: "GET",
      });

      if (resNote.ok) {
        const blob = await resNote.blob(); 
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
      } else {
        console.log("Failed to download notification.");
      }
 

  } catch (error) {
    console.error("Error fetching item data:", error);
  }
};



  return (
    <div className="py-3">
      <div className="row">
        <div className="col-12 mb-4">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-success text-white text-start text-uppercase">
              Latest News / Announcements
            </div>
            <div
              className={`card-body p-3 ${isDarkMode ? "dark-mode-body" : ""}`}
            >
              <ul className="list-group list-group-flush">
                {viewNotifications.length > 0 ? (
                  viewNotifications.map((notification,index) => (
                    <li key={index}
                      className={`list-group-item hover-green ${
                        isDarkMode ? "dark-mode-body" : ""
                      }`}
                    >
                      <FaArrowRight className="me-2" />
                      <span className="content">
                        <span
                          onClick={()=>handleItemClick(notification)}
                          style={{ textDecoration: "none",cursor:"pointer" }}
                        >
                          {notification.title}
                        </span>
                      </span>
                    </li>
                  ))
                ) : (
                  <li
                    className={`list-group-item hover-green ${
                      isDarkMode ? "dark-mode-body" : ""
                    }`}
                  >
                    To be Updated...
                  </li>
                )}
                {notifications.length > 5 && (
                  <li
                    className={`list-group-item hover-green ${
                      isDarkMode ? "dark-mode-body" : ""
                    }`}
                  >
                    <FaArrowRight className="me-2" />
                    <span className="content">
                      <Link to={"/latest-news"} style={{textDecoration:"none"}}>
                        View All
                        </Link>
                    </span>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        <div className="col-12 mb-4">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-success text-white text-start text-uppercase">
              Quick Links
            </div>
            <div
              className={`card-body p-3 ${isDarkMode ? "dark-mode-body" : ""}`}
            >
              <ul className="list-group list-group-flush">
                <li
                  className={`list-group-item hover-green ${
                    isDarkMode ? "dark-mode-body" : ""
                  }`}
                >
                  <FaArrowRight className="me-2" />
                  <Link
                    to={"/internal-complaint-committee"}
                    className="text-decoration-none"
                  >
                    Internal Complaint Committee
                  </Link>
                </li>
                <li
                  className={`list-group-item hover-green ${
                    isDarkMode ? "dark-mode-body" : ""
                  }`}
                >
                  <FaArrowRight className="me-2" />
                  <Link to={"/audit-cell"} className="text-decoration-none">
                    Audit Cell
                  </Link>
                </li>
                <li
                  className={`list-group-item hover-green ${
                    isDarkMode ? "dark-mode-body" : ""
                  }`}
                >
                  <FaArrowRight className="me-2" />
                  <Link
                    to={"/quality-control"}
                    className="text-decoration-none"
                  >
                    Quality Control
                  </Link>
                </li>
                <li
                  className={`list-group-item hover-green ${
                    isDarkMode ? "dark-mode-body" : ""
                  }`}
                >
                  <FaArrowRight className="me-2" />
                  <Link to={"/agreements"} className="text-decoration-none">
                    Grower Agreements
                  </Link>
                </li>
                <li
                  className={`list-group-item hover-green ${
                    isDarkMode ? "dark-mode-body" : ""
                  }`}
                >
                  <FaArrowRight className="me-2" />
                  <Link to={"/rti"} className="text-decoration-none">
                    RTI Act, 2005
                  </Link>
                </li>
                <li
                  className={`list-group-item hover-green ${
                    isDarkMode ? "dark-mode-body" : ""
                  }`}
                >
                  <FaArrowRight className="me-2" />
                  <Link to={"/services"} className="text-decoration-none">
                    Services
                  </Link>
                </li>
                <li
                  className={`list-group-item hover-green ${
                    isDarkMode ? "dark-mode-body" : ""
                  }`}
                >
                  <FaArrowRight className="me-2" />
                  <Link
                    to={"/administration/anti-stubble-buring-campaign"}
                    className="text-decoration-none"
                  >
                    Anti Stubble Burning Campaign
                  </Link>
                </li>
                <li
                  className={`list-group-item hover-green ${
                    isDarkMode ? "dark-mode-body" : ""
                  }`}
                >
                  <FaArrowRight className="me-2" />
                  <Link
                    to={File2}
                    target="_blank"
                    className="text-decoration-none"
                  >
                    CSR Policy
                  </Link>
                </li>
                <li
                  className={`list-group-item hover-green ${
                    isDarkMode ? "dark-mode-body" : ""
                  }`}
                >
                  <FaArrowRight className="me-2" />
                  <Link
                    to={File3}
                    target="_blank"
                    className="text-decoration-none"
                  >
                    Vigil Mechanism Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="col-12 mb-1">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-success text-white text-start text-uppercase">
              Others
            </div>
            <div
              className={`card-body p-3 ${isDarkMode ? "dark-mode-body" : ""}`}
            >
              <div className="row">
                <div className="col-6 my-2">
                  <Link to={"https://www.mygov.in/"} target="_blank">
                    <img src={img2} className="othersImg"></img>
                  </Link>
                </div>
                <div className="col-6 my-2">
                  <Link to={"https://www.mygov.in/"} target="_blank">
                    <img src={img3} className="othersImg"></img>
                  </Link>
                </div>
                <div className="col-6 my-2">
                  <Link to={"https://www.mygov.in/"} target="_blank">
                    <img src={img1} className="othersImg"></img>
                  </Link>
                </div>
                <div className="col-6 my-2">
                  <Link to={"https://www.mygov.in/"} target="_blank">
                    <img src={img4} className="othersImg"></img>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickLinks;
